import { render, staticRenderFns } from "./CampaignStat.vue?vue&type=template&id=399999c0&scoped=true&"
import script from "./CampaignStat.vue?vue&type=script&lang=js&"
export * from "./CampaignStat.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStat.vue?vue&type=style&index=0&id=399999c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399999c0",
  null
  
)

export default component.exports